import PropTypes from 'prop-types';

import styles from './BookingReference.scss';

export const BookingReference = ({ id }) => (
  <strong className={styles.BookingReference}>
    Reference:&nbsp;
    <em>{id}</em>
  </strong>
);

BookingReference.propTypes = {
  id: PropTypes.string.isRequired,
};
